import type { ApiClient } from "@/api/client";

export class BaseApi {
  protected client: ApiClient;

  constructor(client: ApiClient) {
    this.client = client;
  }
}
